import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { faqItems, siteInfo } from '@/mocks/brand';
import useScrollAnimation from '@/hooks/useScrollAnimation';

const HERO_VIDEO_URL = 'https://public.readdy.ai/ai/video_res/01a0ec3c-87b3-72f3-bb2e-807d427a5e0f.mp4';

function FaqHero() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.05 });
  return (
    <section
      ref={ref}
      className="relative min-h-[100svh] flex flex-col items-center justify-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <video
          src={HERO_VIDEO_URL}
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
      </div>

      <div
        className={`relative z-10 flex flex-col items-center text-center px-6 md:px-10 w-full max-w-[720px] transition-all duration-700 ease-out ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <span className="inline-block text-xs text-background-50/60 uppercase tracking-widest mb-4">
          常見問答
        </span>
        <h1
          className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-4"
          style={{ textShadow: '0 2px 12px rgba(0,0,0,0.50), 0 1px 4px rgba(0,0,0,0.30)' }}
        >
          常見問答
        </h1>
        <p
          className="text-background-50/85 text-sm md:text-base leading-relaxed max-w-[560px] text-balance"
          style={{ textShadow: '0 1px 6px rgba(0,0,0,0.45)' }}
        >
          關於沐燁文化 Moya 的品牌定位、書籍查詢、購書通路與合作洽詢，以下是常見問題整理。
        </p>
      </div>
    </section>
  );
}

function FaqList() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.08 });

  return (
    <section
      ref={ref}
      className="relative min-h-[100svh] flex flex-col items-center justify-center bg-background-100 overflow-hidden py-20 md:py-0"
    >
      <div
        className={`relative z-10 flex flex-col items-center px-6 md:px-10 w-full max-w-[760px] transition-all duration-700 ease-out ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <div className="divide-y divide-background-200 w-full">
          {faqItems.map((item, i) => (
            <div key={i} className="py-5">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-start justify-between gap-4 text-left cursor-pointer group"
              >
                <h2 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 pr-8">
                  {item.q}
                </h2>
                <span
                  className={`w-6 h-6 flex items-center justify-center shrink-0 rounded-full border transition-all duration-300 ${
                    openIndex === i
                      ? 'bg-primary-500 border-primary-500 text-background-50 rotate-45'
                      : 'border-foreground-200 text-foreground-400 group-hover:border-primary-300'
                  }`}
                >
                  <i className="ri-add-line text-sm"></i>
                </span>
              </button>
              <div
                className={`grid transition-all duration-300 ease-in-out ${
                  openIndex === i
                    ? 'grid-rows-[1fr] opacity-100 mt-4'
                    : 'grid-rows-[0fr] opacity-0'
                }`}
              >
                <div className="overflow-hidden">
                  <p className="text-sm text-foreground-600 leading-relaxed pb-1">
                    {item.a}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10">
          <a
            href={siteInfo.catalogUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            前往書籍資料庫
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line text-xs"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default function FaqPage() {
  return (
    <>
      <Navbar />
      <main>
        <FaqHero />
        <FaqList />
      </main>
      <Footer />
    </>
  );
}